/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
//import Checkbox from "@material-ui/core/Checkbox";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import * as notif from "components/Notification/notification";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import { useHistory, useRouteMatch } from "react-router-dom";
import {
  loadPaiementForCustomerAction,
  deletePaiementAction,
} from "action/paiementAction";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { Search } from "@material-ui/icons";
import CustomInput from "components/CustomInput/CustomInput";

import stylesSelect from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { useNavigate, useParams } from "react-router-dom-v5-compat";

//import product1 from "assets/img/product1.jpg";

const useStyles = makeStyles(styles);
const useStylesSelect = makeStyles(stylesSelect);
const useStyleAlert = makeStyles(stylesAlert);

const Paiement = (props) => {
  const actualURL = useRouteMatch();
  const [selectFilter, setSelectFilter] = React.useState("");
  const [tableData, setTableData] = useState([]);
  const history = useNavigate();
  const {
    loadPaiementFromSaga,
    paiementLoadDispatch,
    paiementDeleteDispatch,
  } = props;
  const [alert, setAlert] = React.useState(null);
  const [deleteStatut, setDeleteStatut] = React.useState(false);
  const [paramClientId, setParamClientId] = useState("");
  //const [paramPaiementId, setParamPaiementId] = useState(props.match.params.paiementId || 0)
  const paramURLClientID = useParams().id;
  //const paramURLVehiculeID = useParams().vehiculeId

  useEffect(() => {
    setParamClientId(paramURLClientID);
  }, []);

  const dispatchRefreshTable = useCallback(() => {
    const data = {
      idClient: paramClientId,
      filtre: selectFilter,
    };

    paiementLoadDispatch(data);
  }, [paiementLoadDispatch, selectFilter, paramClientId]);

  const handleSelectFilter = (event) => {
    setSelectFilter(event.target.value);
  };

  const loadCardFromSagaUnique = useCallback(() => {
    return loadPaiementFromSaga;
  }, [loadPaiementFromSaga]);

  useEffect(() => {
    dispatchRefreshTable();
  }, [dispatchRefreshTable]);

  useEffect(() => {
    if (deleteStatut === true) {
      if (loadPaiementFromSaga.loading === false) {
        let msg;
        let title;
        if (loadPaiementFromSaga.error.length > 0) {
          title = "Echeque Supression paiement";
          msg = "La paiement n a pas ete suprime";
          notif.showFailedNotification(title, msg);
        } else {
          title = "Supression paiement";
          msg = "La paiement   a ete suprimer";
          notif.showSuccessNotification(title, msg);
          setAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Suprimer!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnCssClass={
                classesAlert.button + " " + classesAlert.success
              }
            >
              Cette article a ete supprimer.
            </SweetAlert>
          );
        }
        setDeleteStatut(false);
      }
    }
  }, [deleteStatut, loadPaiementFromSaga]);

  const handleRefresh = () => {
    console.log("[Paiement] paramClientId => ", paramClientId);
    if (paramClientId) {
      const data = {
        identifiantClient: paramClientId,
      };
      paiementLoadDispatch(data);
    }
  };

  const successDelete = (id) => {
    const data = {
      numeroDeSeriePaiement: id,
    };

    paiementDeleteDispatch(data);
    setDeleteStatut(true);
    /*
    
    */
  };
  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Annuler"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
      >
        Votre article n a pas ete supprimer
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  /*
active: true
dateReceptionPaiement: "2020-11-11T00:00:00.000+00:00"
etatPaiement: "new"
identifiantPaiement: 8
numeroPaiement: "778188858"
numeroDeCommandePaiement: "command"
numeroDeSeriePaiement: "444433"
*/

  const warningWithConfirmAndCancelMessage = (id) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Etes vous sure ?"
        onConfirm={() => successDelete(id)}
        onCancel={() => cancelDetele()}
        confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
        cancelBtnCssClass={classesAlert.button + " " + classesAlert.danger}
        confirmBtnText="Suprimer!"
        cancelBtnText="Annuler"
        showCancel
      >
        Vous ne pourez pas recuperer cette article!
      </SweetAlert>
    );
  };

  const classes = useStyles();
  const classesSelect = useStylesSelect();
  const classesAlert = useStyleAlert();

  const handleButDelete = (id) => {
    warningWithConfirmAndCancelMessage(id);
  };

  const handleButUpdate = (id) => {
    history(`${actualURL.url}/${id}/edit`);
  };

  const handleButShowDetail = (id) => {
    history(`${actualURL.url}/${id}/detail`);
  };

  const roundButtons = (id) => {
    const tabRound = [
      { color: "info", icon: Search, onClick: handleButShowDetail },
      { color: "success", icon: Edit, onClick: handleButUpdate },
      { color: "danger", icon: Close, onClick: handleButDelete },
    ].map((prop, key) => {
      return (
        <Button
          round
          color={prop.color}
          className={classes.actionButton + " " + classes.actionButtonRound}
          key={key}
          onClick={() => {
            prop.onClick(id);
          }}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    });
    return tabRound;
  };

  const statusDatePayement = (date, etat) => {
    if (etat === "EXPIRER") {
      return (
        <img
          src={require("assets/img/emergencylevel/carre_rouge.png")}
          alt={"expirer"}
        />
      );
    } else if (etat === "URGENT") {
      return (
        <img
          src={require("assets/img/emergencylevel/carre_orange.png")}
          alt={"URGENT"}
        />
      );
    } else if (etat === "GOOD") {
      return (
        <img
          src={require("assets/img/emergencylevel/carre_vert.png")}
          alt={"Danns les temps"}
        />
      );
    }
  };

  useEffect(() => {
    const tabLoad = loadPaiementFromSaga.paiements;

    let table = [];
    let cnt = 0;
    if (tabLoad !== undefined) {
      table = tabLoad.map((row) => {
        cnt++;

        return [
          cnt,
          statusDatePayement(row.dateExpiration, row.urgencePayement),
          row.clientMail,
          row.clientNom,
          row.dateExpiration,
          row.datePaiement,
          row.montant,
          roundButtons(row.id),
        ];
      });
      setTableData(table);
    }
  }, [loadCardFromSagaUnique]);

  return (
    <GridContainer>
      {alert}
      <GridItem xs={12}>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-2"
            color="info"
            onClick={() => {
              handleRefresh();
            }}
            disabled={false}
          >
            Refresh List
          </Button>
          <Button
            className="mr-2"
            color="info"
            onClick={() => {
              history(`${actualURL.url}/new`);
            }}
            disabled={false}
          >
            Ajouter paiement
          </Button>
        </div>
        <Card>
          <CardHeader color="info" icon>
            <CardIcon color="info">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Paiement</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={5}>
                <FormControl
                  fullWidth
                  className={classesSelect.selectFormControl}
                >
                  <InputLabel
                    htmlFor="simple-select"
                    className={classesSelect.selectLabel}
                  >
                    Filtre
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classesSelect.selectMenu,
                    }}
                    classes={{
                      select: classesSelect.select,
                    }}
                    value={selectFilter}
                    onChange={handleSelectFilter}
                    inputProps={{
                      name: "selectFilter",
                      id: "simple-select",
                    }}
                  >
                    <MenuItem
                      disabled
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                    >
                      Filtre
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                        selected: classesSelect.selectMenuItemSelected,
                      }}
                      value="tous"
                    >
                      Tous
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="expire"
                    >
                      Expirer
                    </MenuItem>

                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="enRegle"
                    >
                      En regle
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="expireBientot"
                    >
                      Urgent
                    </MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={5}></GridItem>

              <GridItem xs={12} sm={2}>
                <CustomInput
                  labelText="Rechercher"
                  id="Rechercher"
                  formControlProps={{
                    fullWidth: false,
                  }}
                  inputProps={{}}
                />
              </GridItem>
            </GridContainer>

            <Table
              tableHead={[
                "#",
                "status",
                "email",
                "Nom",
                "Expiration",
                "Date Payement",
                "montant",
                "Action",
              ]}
              tableData={tableData}
              customCellClasses={[classes.center, classes.right, classes.right]}
              customClassesForCells={[0, 4, 5]}
              customHeadCellClasses={[
                classes.center,
                classes.right,
                classes.right,
              ]}
              customHeadClassesForCells={[0, 4, 5]}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    loadPaiementFromSaga: state.paiements,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    paiementLoadDispatch: (data) => {
      dispatch(loadPaiementForCustomerAction(data));
    },
    paiementDeleteDispatch: (data) => {
      dispatch(deletePaiementAction(data));
    },
  };
};

export default connect(mapStateToProps, mapsDispatchToProps)(Paiement);
